import { AnnexLineFormTypeEnum } from '@enums/annex-line-form-type.enum';
import { HttpHelper } from '@helpers/http.helper';

export interface ContractAnnexLineJson {
  id: number;
  type: AnnexLineFormTypeEnum;
  label: string;
  charge_choice: string;
  discount_percentage: number;
}

export class ContractAnnexLine {
  constructor(
    public id?: number,
    public type?: AnnexLineFormTypeEnum,
    public label?: string,
    public chargeChoice?: string,
    public discountPercentage?: number
  ) {}

  static fromJson(json: Partial<ContractAnnexLineJson>): ContractAnnexLine {
    return new ContractAnnexLine(json.id, json.type, json.label, json.charge_choice, json.discount_percentage);
  }

  static toJson(model: ContractAnnexLine): ContractAnnexLineJson {
    return {
      id: HttpHelper.toJsonProperty(model.id) ?? undefined,
      type: HttpHelper.toJsonProperty(model.type),
      label: HttpHelper.toJsonProperty(model.label),
      charge_choice: HttpHelper.toJsonProperty(model.chargeChoice),
      discount_percentage: HttpHelper.toJsonProperty(model.discountPercentage)
    };
  }
}
